'use strict';
var utils = require('pagedesigner/util/utils');
var _ = require('lodash');
const $header = $('.sticky-header');
const $stickyCTABanner = $('.sticky-banner');
let lastTop = 0;

// When the user scrolls to the threshold value, the header slides up and sticky CTA banner slides down
// When the user scrolls up on a given page on the site, the header will reappear.
// Used this method: https://medium.com/@mariusc23/hide-header-on-scroll-down-show-on-scroll-up-67bbaae9a78c

/**
 * handle scroll
 * @param  {number} lastTop - last top position
 */
function hasScrolled() {
    const scrollTriggerMobile = $stickyCTABanner.data('mobile-threshold') || 100;
    const scrollTriggerDesktop = $stickyCTABanner.data('desktop-threshold') || 100;

    // get top scroll position
    let scrollTop = $(window).scrollTop();

    // If we have not scrolled past the threshold, do nothing
    if (utils.mediaBreakpointDown('md') && Math.abs(lastTop - scrollTop) <= scrollTriggerMobile) {
        return;
    }

    if (utils.mediaBreakpointUp('lg') && Math.abs(lastTop - scrollTop) <= scrollTriggerDesktop) {
        return;
    }

    // If current position > last position AND scrolled past trigger threshold (viewport based)
    if (scrollTop > lastTop && ((utils.mediaBreakpointDown('md') && scrollTop > scrollTriggerMobile) || (utils.mediaBreakpointUp('lg') && scrollTop > scrollTriggerDesktop))) {
        // hide the nav, bring sticky buy bar up
        $header.addClass('move-up');
        $stickyCTABanner.removeClass('move-up');
    } else if (scrollTop < lastTop && $header.hasClass('move-up')) {
        // if the pages is scrolled up, reset the banner
        $header.removeClass('move-up');
        $stickyCTABanner.addClass('move-up');
    }

    lastTop = scrollTop;
}
/**
 * Update positioning of mobile ATC
 */
function updateMobileAtc() {
    var $stickyAtcContainer = $('.sticky-atc-container');
    if (window.scrollY > 75) {
        $($stickyAtcContainer).css({
            top: 0,
            position: 'fixed'
        });
        $('#nav-display-control .icon-icon-chevron-up-white:visible').click();
    } else {
        $($stickyAtcContainer).css({
            position: 'relative'
        });
    }
}
/**
 * Toggle visibility of product navigation
 */
function toggleProductNav() {
    $('.product-nav').slideToggle(400);
    $('#nav-display-control .icon-icon-chevron-down-white, #nav-display-control .icon-icon-chevron-up-white').toggle();
    if ($('#nav-display-control .icon-icon-chevron-up-white:visible').length > 0) {
        $('#nav-display-control').attr('aria-label', 'Contract product navigation menu');
    } else {
        $('#nav-display-control').attr('aria-label', 'Expand product navigation menu');
    }
}

var pdStickyComponents = {
    /**
     * @function
     * @desc Makes sure the page has proper top padding
     */
    initStickyHeader: function () {
        let headerHeight = $header.outerHeight();
        $header.closest('.storepage').css('padding-top', headerHeight);
    },
    /**
     * @function
     * @desc Inits the Sticky CTA Payment Banner
     */
    initBanner: function () {
        $(window).on('scroll', _.throttle(function () {
            hasScrolled(lastTop);
        }, 250));

        // set strike through price color
        let $strikePrice = $stickyCTABanner.find('.strike-through');
        if ($strikePrice.length > 0) {
            let strikeColor = $('[data-strike-color]').data('strike-color');
            $strikePrice.find('.value').addClass(strikeColor);
        }
    },
    /**
 * Calculate position of mobile sticky atc below header, account for mobile search open/close
 */
    stickyAtcEvents: function () {
        document.addEventListener('scroll', function () {
            updateMobileAtc();
        });
        $('.search-glass-interactive').click(function () {
            updateMobileAtc();
        });
        $('#nav-display-control').click(function () {
            toggleProductNav();
        });
    }

};

module.exports = pdStickyComponents;
